import { apiClient } from './client';
import type { Asset } from '@/types/entities';

export const assetsApi = {
  getAllByTenantSlug: (tenantSlug: string) => apiClient.get<Asset[]>(`/tenants/${tenantSlug}/assets`),
  deleteByTenantSlug: (tenantSlug: string, assetId: number) => apiClient.delete<void>(`/tenants/${tenantSlug}/assets/${assetId}`),
  upload: async (tenantSlug: string, file: File, name?: string) => {
    const formData = new FormData();
    
    // Name first before file.
    if (name) {
        formData.append('name', name);
    }
    formData.append('file', file);

    return apiClient.request<Asset & { path: string }>(`/tenants/${tenantSlug}/assets`, {
      method: 'POST',
      body: formData,
      headers: {},
    });
  },
};
